import { useEffect } from 'react';

import { connectCqrsWebsocketClient } from './cqrs';

export const CqrsWebsocket = (): null => {
   useEffect(connectCqrsWebsocketClient);
   return null;
};
